<template>
  <div class="field-container">
    <label class="field-name">{{ fieldName }}</label>

    <slot />
  </div>
</template>

<script>
export default {
  name: "ReportField",

  props: {
    fieldName: {
      type: String
    }
  }
};
</script>

<style scoped>
.field-container {
  max-width: 1000px;
  width: 100%;
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 12px;
}

.field-name {
  margin-bottom: 10px;
  font-size: 14px;
}
.field-container input {
  width: 100%;
  height: 32px;
  padding: 5px;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 2px;
}
.field-container.disabled input {
  background: #f9f9f9;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportField.vue